import { css } from '@emotion/css'
import Box from '@mui/material/Box'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import moment from 'moment/moment'
import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link, useLocation } from 'react-router-dom'
import DataUnit from '../../../../components/customElements/DataUnit/DataUnit'
import FormInput from '../../../../components/customElements/FormInput'
import InputField from '../../../../components/customElements/InputField/InputField'
import ChangeInstallationDate from '../../../../components/customElements/RequestDataAccordions/ChangeInstallationDate'
import FinancialSourceAccordio from '../../../../components/customElements/RequestDataAccordions/FinancialSourceAccordio'
import HasDuplicates from '../../../../components/customElements/RequestDataAccordions/HasDuplicates'
import InstallationData from '../../../../components/customElements/RequestDataAccordions/InstallationData'
import OrderStatus from '../../../../components/customElements/RequestDataAccordions/OrderStatus'
import RequestInfo from '../../../../components/customElements/RequestDataAccordions/RequestInfo'
import SetEquipmentId from '../../../../components/customElements/RequestDataAccordions/SetEquipmentId'
import UploadedPhotos from '../../../../components/customElements/RequestDataAccordions/UploadedPhotos'
import CustomAccordion from '../../../../components/customElements/RequestDataAccordions/utils/CustomAccordion'
import RightDrawer from '../../../../components/customElements/RightDrawer/RightDrawer'
import OrderInfoChips from '../../../../components/OrderInfoChips/OrderInfoChips'
import CommentsBlock from '../../../../components/RequestCommentsBlock/CommentsBlock'
import { useGetReceiverModels } from '../../../../hooks/useGetReceiverModels'
import {
  isDealer,
  isLooker,
  isSuspiciousDealer,
} from '../../../../services/AccountService'
import requestsManagementStore from '../../../../stores/RequestsManagementStore'
import commonStyles from '../../../../styles/commonStyles'
import { gState } from '../../../../utils/controllers/GlobalStateController'
import {
  closeModalFn,
  isModalOpen,
  modalData,
} from '../../../../utils/controllers/ModalController'
import { getStyles } from '../../../../utils/utils/commonUtils'
import { getComp } from '../../../../utils/utils/DI'
import InstallationRequestStore from '../../stores/InstallationRequestStore'
import AddInformationContent from '../utils/AddInformationContent'
import PhotosUpload from '../utils/PhotosUpload'
import ActionButtons from './components/ActionButtons'
import ChangeStatusView from './components/ChangeStatusView'
import InstallationDataAccNew from './components/InstallationDataAccNew'

const store = new InstallationRequestStore({
  ordersStore: requestsManagementStore.ordersStore,
})

// у дилера в этих статусах видна дата созданния (RequestInfo)
export const requestInfoDealerStatuses = [2, 4, 5, 6, 7, 11, 12, 13, 14, 15, 16]

function InstallationRequestDrawer({ ordersStore }) {
  const intl = gState['intl']
  const classes = getStyles(commonStyles)
  const { pathname } = useLocation()

  const {
    data,
    setNewEquipment,
    newEquipment,
    clear,
    startUpdate,
    toDefaultStep,
    comment,
    setComment,
    addInformation,
    setSelectedOrder,
    isChangeStatusState,
    installationDateInput,
    setInstallationDateInput,
    changeInstallationDate,
    isEditInfo,
    toggleEditInfo,
    isEdit,
    photoSettings: { photoPermission },
    setOrderDataRequest,
    serviceInformationAccordionFormStore,
    receiverData,
    getReceiversFunc,
  } = store

  const {
    id,
    status,
    dealer,
    installationDate,
    equipmentId,
    dataCheckingStatus,
    hasDuplicates,
    reportStatus,
    reportId,
    receiverId,
    authorId,
    financialSourceId,
  } = data
  const { data: serviceReceivers } = useGetReceiverModels()

  const [editInstallationDate, setEditInstallationDate] = useState(false)
  const [editDataDealer, setEditDataDealer] = useState(false)
  const changeCreationDateCallback = () => {
    store.ordersStore.updateOrder(id)
  }

  useEffect(() => {
    if (receiverId) {
      getReceiversFunc(receiverId)
    }
  }, [receiverId])

  useEffect(() => {
    if (isModalOpen['installation-request']) {
      store.updateDrawerData()
    }
  }, [isModalOpen['installation-request']])

  useEffect(() => {
    serviceInformationAccordionFormStore.clear()
    if (isModalOpen['installation-request']) {
      setSelectedOrder()
    } else {
      clear()
    }
  }, [isModalOpen['installation-request']])

  const closeModals = () => {
    if (isEdit && isEditInfo) {
      toggleEditInfo()
    } else {
      setEditDataDealer(false)
    }
    closeModalFn['photo-gallery']()
    closeModalFn['installation-request']()
    setEditInstallationDate(false)
  }
  const statusStore = getComp('StatusesStore')
  const { getStatusName } = statusStore
  const [error, setError] = useState(null)
  const [fins, setFins] = useState([])

  useEffect(() => {
    const territoryStore = getComp('TerritoryStore')
    const { territories } = territoryStore
    const { district, locality, territory } = data

    if (!territories || Object.keys(territories).length === 0) {
      setError('No territories available in the store')
      return
    }

    const findTerritory = territories[territory]
    if (!findTerritory) {
      setError(`Territory ${territory} not found`)
      return
    }

    const findDistrict = findTerritory.Territory?.Districts.find(
      (el) => el.Name === district,
    )
    if (!findDistrict) {
      setError(`District ${district} not found in territory ${territory}`)
      return
    }

    const findLocality = findDistrict.Localities.find(
      (el) => el.Name === locality,
    )
    if (!findLocality) {
      setError(`Locality ${locality} not found in district ${district}`)
      return
    }

    const allowedFinancialSourceIds = findLocality.AllowedFinancialSourceIds
    if (!allowedFinancialSourceIds) {
      setError(
        `Allowed financial source IDs not found for locality ${locality}`,
      )
      return
    }

    setFins(allowedFinancialSourceIds)
    setError(null)
  }, [data, id])

  // Для второго InstallationData
  const isDealerAndCanEdit = isDealer() && [2, 4, 5].includes(status)
  const isDealerEditAllowed =
    isDealer() && status === 6 && dataCheckingStatus === 0
  const isSuspiciousDealerEditAllowed =
    isSuspiciousDealer() &&
    isDealerAndCanEdit &&
    !([1].includes(financialSourceId) && fins.includes(1))
  const isAuthorCanEdit =
    isDealer() &&
    getComp('UserInfoStore').userId === authorId &&
    status === 6 &&
    dataCheckingStatus === 3
  const isAuthorCanToggleEditDealer =
    isDealer() && status === 6 && dataCheckingStatus === 2

  const handleEdit = () => {
    if (isSuspiciousDealerEditAllowed || isAuthorCanEdit) return null
    if (isEdit && !isDealerEditAllowed) return toggleEditInfo
    if (isDealerAndCanEdit || isAuthorCanToggleEditDealer) {
      return () => setEditDataDealer((prev) => !prev)
    }
    return null
  }

  const hideForDealer = isDealer() && status === 11
  const hideReceiverInfo =
    [5, 6, 7].includes(status) || pathname.includes('requests')

  // Для второго InstallationData
  return (
    <RightDrawer
      open={isModalOpen['installation-request']}
      onClose={closeModals}
      loading={startUpdate}
      title={
        <>
          <FormattedMessage id={'Заявка'} /> №{id}
        </>
      }
      backButtonClick={
        addInformation || isChangeStatusState ? toDefaultStep : null
      }
    >
      {isModalOpen['installation-request'] ? (
        <Box height={1}>
          <Box
            name={'content'}
            className={classNames('fx-col jst-sb', css(classes.drawerContent))}
          >
            {addInformation ? (
              <AddInformationContent store={store} />
            ) : isChangeStatusState ? (
              <ChangeStatusView comment={comment} setComment={setComment} />
            ) : isEdit &&
              isEditInfo &&
              !(isDealer() || isSuspiciousDealer()) ? (
              <InstallationData
                order={data}
                defaultOpenState
                onEdit={toggleEditInfo}
                isEdit={true}
                filterStore={modalData['installation-request'].filterStore}
                ordersStore={modalData['installation-request'].ordersStore}
              />
            ) : (
              <Box>
                <Box sx={classes.drawerStatusesInfo}>
                  <OrderStatus status={status} dealer={dealer} />
                  {status >= 12 && isDealer() && !isLooker() ? (
                    <Link target='_blank' to={`/reports/${reportId}`}>
                      <OrderInfoChips
                        tooltip={getStatusName(reportStatus, true)}
                        id={reportId} // id отчета
                        reportStatus={reportStatus} // статус отчета
                        haveChips={true} // регулирует наличие фона по типу чипса
                        showOrderStatusIcon={true} // регулирует отображение иконки статуса
                      />
                    </Link>
                  ) : null}
                </Box>
                {hasDuplicates && (
                  <Box
                    className={'fx-center'}
                    sx={{
                      padding: '8px 16px 16px',
                      width: '100%',
                    }}
                  >
                    <DataUnit
                      value={intl.formatMessage({
                        id: 'Отмечена как повторная заявка',
                      })}
                    />
                  </Box>
                )}
                {status === 4 ? (
                  isEdit && status !== 2 ? (
                    <SetEquipmentId
                      store={store}
                      newEquipmentValue={newEquipment}
                    />
                  ) : isDealer() && status === 5 ? null : (
                    <CustomAccordion
                      summary={intl.formatMessage({ id: 'Id оборудования' })}
                    >
                      {status === 6 ? (
                        <DataUnit value={equipmentId ?? newEquipment} />
                      ) : (
                        <Box sx={{ paddingTop: '24px' }}>
                          <InputField
                            value={equipmentId ?? newEquipment}
                            onChange={setNewEquipment}
                            readOnly={!!equipmentId && !isEdit}
                            styles={{ marginTop: '8px' }}
                            label={intl.formatMessage({
                              id: 'Id оборудования',
                            })}
                            fullWidth
                          />
                        </Box>
                      )}
                    </CustomAccordion>
                  )
                ) : null}
                {isDealer() && requestInfoDealerStatuses.includes(status) && (
                  <RequestInfo request={data} defaultOpenState />
                )}
                <InstallationData
                  order={data}
                  defaultOpenState
                  isEdit={
                    editDataDealer ||
                    (isEditInfo && isDealerAndCanEdit) ||
                    (isEditInfo && isAuthorCanToggleEditDealer)
                  }
                  requestStore={store}
                  onEdit={handleEdit()}
                  ordersStore={modalData['installation-request'].ordersStore}
                />
                <FinancialSourceAccordio data={store.data} />
                {isDealer() &&
                  getComp('UserInfoStore').userId === authorId &&
                  ([2, 4, 14].includes(status) ||
                    (status === 6 && [0, 2].includes(dataCheckingStatus))) && (
                    <HasDuplicates
                      data={store.data}
                      onChange={setOrderDataRequest}
                    />
                  )}
                {!isDealer() && (
                  <>
                    {photoPermission.isWorking ? (
                      <Box>
                        <CustomAccordion
                          defaultOpenState={true}
                          summary={intl.formatMessage({
                            id: 'Данные установки',
                          })}
                        >
                          <>
                            {[5, 6].includes(status) ? (
                              <DataUnit
                                value={equipmentId ?? newEquipment}
                                name='Id оборудования'
                              />
                            ) : (
                              <Box sx={{ paddingTop: '10px' }}>
                                <InputField
                                  value={equipmentId ?? newEquipment}
                                  onChange={setNewEquipment}
                                  readOnly={!!equipmentId && !isEdit}
                                  styles={{ marginTop: '8px' }}
                                  label={intl.formatMessage({
                                    id: 'Id оборудования',
                                  })}
                                  fullWidth
                                />
                              </Box>
                            )}
                            <Box>
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: '14px',
                                  paddingTop: '21px',
                                }}
                              >
                                {status === 110 ? (
                                  <>
                                    <FormInput
                                      type='select'
                                      api={serviceInformationAccordionFormStore}
                                      propName={'receiverModelId'}
                                      label={intl.formatMessage({
                                        id: 'Модель оборудования',
                                      })}
                                      fullWidth
                                      placeholder={'Модель оборудования'}
                                      items={serviceReceivers.map((el) => ({
                                        key: `${el.name} - ${el.manufacturerName}`,
                                        value: el.id,
                                      }))}
                                      withoutErrorText={true}
                                    />
                                    <FormInput
                                      type='text'
                                      api={serviceInformationAccordionFormStore}
                                      propName={'receiverSerialNumber'}
                                      label={intl.formatMessage({
                                        id: 'Серийный номер',
                                      })}
                                      fullWidth
                                      placeholder={'Серийный номер'}
                                      withoutErrorText={true}
                                    />
                                  </>
                                ) : null}
                              </Box>
                            </Box>
                            <Box mt={2}>
                              <InputField
                                mt={2}
                                value={installationDateInput}
                                onChange={setInstallationDateInput}
                                label={intl.formatMessage({
                                  id: 'Дата установки',
                                })}
                                mask={'99-99-9999'}
                                placeholder={'DD-MM-YYYY'}
                                error={
                                  (installationDateInput.length < 10 ||
                                    !moment(
                                      installationDateInput,
                                      'DD-MM-YYYY',
                                    ).isValid() ||
                                    moment().diff(
                                      moment(
                                        installationDateInput,
                                        'DD-MM-YYYY',
                                      ),
                                    ) < 0) &&
                                  intl.formatMessage({
                                    id: 'Введите корректную дату',
                                  })
                                }
                                fullWidth={true}
                              />

                              <PhotosUpload
                                store={store}
                                title={intl.formatMessage(
                                  {
                                    id: `Загрузите от {minimumLimit} до {maximumLimit} фотографий`,
                                    defaultMessage: `Загрузите от {minimumLimit} до {maximumLimit} фотографий`,
                                  },
                                  {
                                    minimumLimit:
                                      photoPermission.minLimitPerLoad,
                                    maximumLimit:
                                      photoPermission.maxLimitPerLoad,
                                  },
                                )}
                              />
                            </Box>
                          </>
                        </CustomAccordion>
                      </Box>
                    ) : (
                      ![2, 4, 5].includes(status) && (
                        <CustomAccordion
                          defaultOpenState={isDealer() && status === 6}
                          onEdit={
                            (isEdit || isDealerEditAllowed) &&
                            status === 6 &&
                            data?.dataCheckingStatus === 0
                              ? () => setEditInstallationDate((prev) => !prev)
                              : false
                          }
                          summary={intl.formatMessage({
                            id: 'Данные установки',
                          })}
                        >
                          {!hideForDealer && (
                            <>
                              {[7].includes(status) ? null : (
                                <Box mt={2}>
                                  <DataUnit
                                    name='Id оборудования'
                                    value={equipmentId || 'Не заполнен'}
                                  />
                                </Box>
                              )}

                              {hideReceiverInfo ? null : (
                                <Box>
                                  <Box mt={2}>
                                    <DataUnit
                                      name='Модель оборудования'
                                      value={
                                        serviceReceivers.find(
                                          (receiver) =>
                                            receiver.id ===
                                            receiverData.modelId,
                                        )?.name
                                          ? `${
                                              serviceReceivers.find(
                                                (receiver) =>
                                                  receiver.id ===
                                                  receiverData.modelId,
                                              )?.name
                                            } - ${
                                              serviceReceivers.find(
                                                (receiver) =>
                                                  receiver.id ===
                                                  receiverData.modelId,
                                              )?.manufacturerName
                                            }`
                                          : 'Не заполнена'
                                      }
                                    />
                                  </Box>
                                  <Box mt={2}>
                                    <DataUnit
                                      name='Серийный номер'
                                      value={
                                        receiverData?.serialNumber ||
                                        'Не заполнен'
                                      }
                                    />
                                  </Box>
                                </Box>
                              )}
                            </>
                          )}
                          {editInstallationDate &&
                          status <= 6 &&
                          data?.dataCheckingStatus === 0 ? (
                            <Box mt={2}>
                              {[6, 12, 13, 15, 16].includes(status) && (
                                <ChangeInstallationDate
                                  inputData={installationDate}
                                  requestId={id}
                                  requestStatus={status}
                                  changeInstallationDate={
                                    changeInstallationDate
                                  }
                                  reloadAction={changeCreationDateCallback}
                                  reportOrder={
                                    !!dataCheckingStatus && status !== 6
                                  }
                                  ordersStore={ordersStore}
                                />
                              )}
                            </Box>
                          ) : isDealer() && [7, 11].includes(status) ? null : (
                            <Box mt={2}>
                              <DataUnit
                                name='Дата установки'
                                value={moment(installationDate)
                                  .startOf('day')
                                  .format('DD-MM-YYYY')}
                              />
                            </Box>
                          )}
                          <UploadedPhotos
                            store={store}
                            order={data}
                            defaultOpenState={true}
                          />
                        </CustomAccordion>
                      )
                    )}
                  </>
                )}
                {isDealer() && data?.status >= 5 && (
                  <InstallationDataAccNew
                    store={store}
                    request={data}
                    photoPermission={photoPermission}
                  />
                )}
                <CommentsBlock store={store} />
              </Box>
            )}
            {isEditInfo ? null : <ActionButtons store={store} />}
          </Box>
        </Box>
      ) : null}
    </RightDrawer>
  )
}

export default observer(InstallationRequestDrawer)
